import { render } from "./Newsletter.vue?vue&type=template&id=701d453a"
import script from "./Newsletter.vue?vue&type=script&lang=js"
export * from "./Newsletter.vue?vue&type=script&lang=js"
script.render = render

export default script